import React, { useCallback, useState } from 'react';
import { Popover } from 'antd';
import { Button, IconButton_IconSizes } from '@ydistri/ds';
import SkuSalePopoverChart from './SkuSalePopover';
import { ImStatsDots } from 'react-icons/im';

interface SkuSalePopoverProps {
  skuId: number;
}

const SkuSalePopover: React.FC<SkuSalePopoverProps> = ({ skuId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleOpenChange = useCallback((open: boolean) => {
    setIsOpen(open);
  }, []);

  const handleKeyDownCapture = useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (!isOpen || event.key !== 'Escape') return;

      event.preventDefault();
      event.stopPropagation();
      handleClose();
    },
    [handleClose, isOpen],
  );

  return (
    <div onKeyDownCapture={handleKeyDownCapture}>
      <Popover
        trigger="click"
        content={<SkuSalePopoverChart skuId={skuId} onClose={handleClose} />}
        arrow={false}
        open={isOpen}
        onOpenChange={handleOpenChange}
      >
        <Button $colorVariant="ghost" $sizeVariant="xSmall">
          <ImStatsDots size={IconButton_IconSizes.xSmall} />
        </Button>
      </Popover>
    </div>
  );
};

export default SkuSalePopover;
